module.exports = __webpack_public_path__ + "5fd9f72d8fa232151aa4af9a02e284d2.png";